import { SegmentedControl } from "../../ui/SegmentedControl";
import {
  MAX_REPORT_DAYS,
  periodDays,
  rangeDays,
  type ReportPeriodPreset,
  type ReportPeriodValue,
} from "../../../utils/reportPeriods";

const OPTIONS: { value: ReportPeriodPreset; label: string }[] = [
  { value: "THIS_MONTH", label: "This month" },
  { value: "LAST_MONTH", label: "Last month" },
  { value: "LAST_7_DAYS", label: "Last 7 days" },
  { value: "CUSTOM", label: "Custom" },
];

/** G-143 — the period control the By shop tab and the person page share. */
export function ReportPeriodPicker({
  value,
  onChange,
}: {
  value: ReportPeriodValue;
  onChange: (next: ReportPeriodValue) => void;
}) {
  return (
    <div className="field">
      <label id="wo-period-label">Period</label>
      <SegmentedControl
        ariaLabel="Period"
        options={OPTIONS}
        value={value.preset}
        onChange={(preset) =>
          onChange({
            preset,
            // Custom starts from what was on screen, so the two days are never empty.
            custom: preset === "CUSTOM" && value.preset !== "CUSTOM" ? (periodDays(value) ?? value.custom) : value.custom,
          })
        }
      />
      {value.preset === "CUSTOM" ? (
        <div className="wo-custom-range">
          <input
            type="date"
            aria-label="From"
            value={value.custom.from}
            onChange={(e) => onChange({ ...value, custom: { ...value.custom, from: e.target.value } })}
          />
          <input
            type="date"
            aria-label="To"
            value={value.custom.to}
            onChange={(e) => onChange({ ...value, custom: { ...value.custom, to: e.target.value } })}
          />
          {value.custom.from && value.custom.to && rangeDays(value.custom) > MAX_REPORT_DAYS ? (
            <span className="wo-range-error" role="alert">
              At most {MAX_REPORT_DAYS} days
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
